import React from 'react';
import NCLeftOvers from 'components/Tvendo/Sale/Operations/NCredito/NCSharedFile.js';

export default function () {
  return <NCLeftOvers type="NCL" title="NC sobrantes" />;
}
